.header {
  align-items: center;
  border-bottom: 1px solid var(--dark-4);
  display: flex;
  gap: 10px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.invoicesTable {
  .header {
    border-bottom: 1px solid var(--dark-4);
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 0;

    .invoice {
      padding-left: 12px;
    }
  }

  .date {
    flex-grow: 1;
  }

  .amount {
    width: 100px;
  }

  .type {
    width: 132px;
    overflow: hidden;
    min-width: 0;

    span {
      display: block;
      width: 100%;
    }
  }

  .invoice {
    width: 80px;
  }

  .cell {
    padding: 8px 0 8px 8px;
  }

  .body {
    display: flex;
    flex-direction: column;
  }

  .invoiceRow {
    display: flex;
    align-items: center;
    height: 47px;
    gap: 8px;
  }

  .rolePill {
    border-radius: 16px;
    background: var(--dark-4);
    display: flex;
    padding: 2px 6px;
    align-items: center;
    gap: 4px;
    color: var(--dark-80);
    text-align: center;
    font-family: Sohne;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 139%; /* 16.68px */
    letter-spacing: 0.36px;
  }
}
